import {
  Button,
  ExpandablePanel,
  ExpandablePanelBody,
  ExpandablePanelHeader,
  Typography,
} from "@king-ict/eupisi-ui/components";
import { getInstitutionDisplayNameAndTown } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import InstitutionProgram from "../../../models/Institution/InstitutionProgram";
import styles from "./RequestDetailsPage.module.scss";

interface Props {
  institutionPrograms: InstitutionProgram[];
  moveToSpecificStep?: (step: number, substep?: number) => void;
  onExpandablePanelClick?: () => void;
}

export default function InstitutionProgramDetails({
  institutionPrograms,
  moveToSpecificStep,
  onExpandablePanelClick,
}: Props) {
  const { t } = useTranslation();

  const renderInstitutionPrograms = () => {
    if (institutionPrograms.length > 0) {
      return institutionPrograms.map((institutionProgram) => {
        return (
          <Row
            key={institutionProgram.pedagogicalYearInstitutionProgramDetailId}
          >
            <Col md={5}>
              <Typography variant="base" color="light">
                {getInstitutionDisplayNameAndTown(
                  institutionProgram.locationName!,
                  institutionProgram.locationTown!
                )}
              </Typography>
            </Col>
            <Col md={5}>
              <Typography variant="base" color="light">
                {institutionProgram.programName}
              </Typography>
            </Col>
          </Row>
        );
      });
    }
  };

  return (
    <>
      <Row className={styles.rowSpace}>
        <Col md={12}>
          <ExpandablePanel clickableHeader>
            <ExpandablePanelHeader onClick={onExpandablePanelClick}>
              {t("requestReviewStep.locationProgram")}
            </ExpandablePanelHeader>
            <ExpandablePanelBody>
              <Row className={styles.rowSpace}>
                <Col md={10}></Col>
                {moveToSpecificStep && (
                  <Col md={2}>
                    <Button
                      size="sm"
                      outline
                      onClick={() => moveToSpecificStep(2, 1)}
                    >
                      {t("common.edit")}
                    </Button>
                  </Col>
                )}
              </Row>
              <Row>
                <Col md={5}>
                  <Typography variant="baseBold">
                    {t("requestReviewStep.location")}
                  </Typography>
                </Col>
                <Col md={5}>
                  <Typography variant="baseBold">
                    {t("requestReviewStep.programType")}
                  </Typography>
                </Col>
              </Row>
              {renderInstitutionPrograms()}
            </ExpandablePanelBody>
          </ExpandablePanel>
        </Col>
      </Row>
    </>
  );
}
